import React, { Component } from "react";
import InputText from "../../../../../common/components/input-text/input-text";
import Button from "../../../../../home/button-classic/button-classic";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { connect } from "react-redux";
import ACTION from "../../../../../common/action_constant";
import { getCookie } from "../../../../../utils/cookies.js";
import Switch from "react-switch";
import { getUserCompanyId, AWL_COMPANY_IDS, DEEPAK_COMPANY_ID } from "../../../../../utils/common";
import { validationCheck } from "../../../../../utils/validate";
import { setItemToSessionStorage } from "../../../../../utils/sessionStorage.js";
import actions from "../../../../../common/action_constant";
 
class AddItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        company_id: JSON.parse(getCookie("user")).company_id,
        user_id: this.props.data.user_id,
        driver_id: this.props.data.driver_id,
        user_name:this.props.data.user_name,
        driver_name: this.props.data.driver_name,
        cell_no: this.props.data.cell_no,
        dl_no: this.props.data.dl_no,
        dob: this.props.data.dob,
        driver_acc_no: this.props.data.driver_acc_no,
        driver_ifsc_code: this.props.data.driver_ifsc_code,
        driver_alternative_location_id: this.props.data.driver_alternative_location_id,
        preferredroute: this.props.data.preferredroute || [],
        // user_name: this.props.data.user_name,
        driver_detail_validity_date: this.props.data.driver_detail_validity_date || new Date(),
        block_data:this.props.data.block_data || [],
        dlName:this.props.data.dlName,
        is_blocked: this.props.data.is_blocked || false,
        block_remarks: this.props.data.block_remarks || '',
        blocked_by: this.props.data.blocked_by || '' ,
        unblock_remarks: this.props.data.unblock_remarks || '',  
        unblocked_by: this.props.data.unblocked_by || '',
        unblocked_user_id: this.props.data.unblocked_user_id || '',
        unblock_data:this.props.data.unblock_data || []
      },
      blockedUser: false,
      errorMsg: "",
    };
  }
 
  componentDidMount() {
    // this.props.getCompanyTransporters();
    setItemToSessionStorage('driverIn', this.props.data);
  }
 
  handleChange = (id, selectedOption) => {
    let { data } = this.state;
    data[id] = selectedOption.label;
    this.setState({ data });
  };
 
  onChangeHandler = (value, id, isType) => {
    let { data } = this.state;
    if (id === 'driver_ifsc_code' || id === 'dl_no'){
      value = value.replace(/[^A-Za-z0-9]/g, '');
      value = value.slice(0, 16);
    }
    const result = validationCheck(value, this.state.data[id], isType);
    data[id] = result;
    this.setState({ data });
  };
 
  SelectDate = (id, selectedOption) => {
    let { data } = this.state;
    data[id] = selectedOption != null ? selectedOption.valueOf() : null;
    this.setState({ data });
  };
  onSave = () => {
    const { data } = this.state;
    const {driver_detail_validity_date, dob } = this.state.data;
    if(!!data.is_blocked){
      data.blocked_by = JSON.parse(getCookie("user")).admin_name
            || JSON.parse(getCookie("user")).user_name
            || '';
    }
    if(!data.is_blocked){
       data.is_blocked = data.is_blocked;
       data.unblocked_by = JSON.parse(getCookie("user")).admin_name
             || JSON.parse(getCookie("user")).user_name
             || '';
       data.unblocked_user_id = JSON.parse(getCookie("user")).user_id;
    }
    // Basic field validation
    if (!this.validateCheck()) {
      this.setState({
        errorMsg: "Please add all mandatory fields",
      });
      return;
    }
    // const hasMaskedData = [
    //   data.driver_name,
    //   data.cell_no,
    //   data.driver_alternative_location_id,
    // ]
    //   .filter(Boolean)
    //   .some((field) => field.includes("*"));
 
  //   if (hasMaskedData) {
  //     this.setState({
  //       errorMsg:
  //         "Some fields contain masked (*) data. Please enter complete driver details before saving.",
  //     });
  //   return;
  // }
 
  // if (dob && moment().diff(moment(dob), "years") < 18) {
  //   this.setState({ errorMsg: "Driver must be at least 18 years old." });
  //   return;
  // }
  //   data.driver_detail_validity_date = driver_detail_validity_date
  //   ? driver_detail_validity_date.valueOf()
  //   : undefined;
 
  this.setState({ errorMsg: "" });
  this.props.toggleAdd("Edit");
  this.props.updateDriverInfo(data);
};
  validateCheck = () => {
    const { data } = this.state;
    const isDpl = DEEPAK_COMPANY_ID.includes(data.company_id);
    if (isDpl) {
      return !!(data.driver_name && data.dl_no && data.cell_no);
    }
    return !!(
      data.driver_name && data.cell_no && data.dl_no && data.driver_detail_validity_date && data.dlName);
  };
  addLocation = () => {
    let { data } = this.state;
    data.preferredroute.push({ source: "", destination: "" });
    this.setState({ data });
  };
  deleteLocation = (index) => {
    const { data } = this.state;
    data.preferredroute.splice(index, 1);
    this.setState({ data });
  };
 
  uploadfiles = (e, name) => {
    const { dispatch } = this.props;
    const { driverinfo } = this.state.data;
    console.log("edit data",driverinfo)
    let formData = new FormData();
    formData.append("file", e.target.files[0]);
    dispatch({
      type: ACTION.DATA_GOVERNANCE.UPLOAD_VEHICLE_FIELS,
      formData,
      onSuccess: (details) => {
        const { data } = this.state;
        data[name] = details;
        this.setState({ data });
      },
    });
  };
  onUpload = () => {
    this.uploadUrl.click();
  };
     handleFileClickWithpresignedUrl = (name = "") => {
 
    const { dispatch } = this.props;
 
    dispatch({
 
      type: actions.HOME.GET_PRESIGNED_DOWNLOAD_URL,
 
      fileName: name,
      trip_id: "",
      method_name: "",
 
      onSuccess: ((link) => {
 
        console.log("link", link);
 
        window.open(link, '_blank');
 
      })
 
    })
 
  }
 
handleSwitch = (checked) => {
  let { data } = this.state;
  data.is_blocked = checked;
  data.blocked_by =
    JSON.parse(getCookie("user")).admin_name ||
    JSON.parse(getCookie("user")).user_name ||
    '';
  
  if (checked) {
    data.block_remarks = '';
  } else {
    data.unblock_remarks = '';
  }
 
  this.setState({ data, blockedUser: true });
};
  onChange = (e) => {
      this.uploadfiles(e, "dlName");
  }
  render() {
    let block=this.state.data.is_blocked;
    let { data, blockedUser } = this.state;
    const company_id = data.company_id;
    let {block_data,unblock_data}=this.state.data;
    let isBlocked = block_data.filter(block => block.company_id === getUserCompanyId() && block.is_blocked === true)
    let isUnBlocked = unblock_data.filter(block => block.company_id === getUserCompanyId() && block.is_blocked === false)
 
  if (!blockedUser) {
  if (isBlocked && isBlocked.length > 0) {
    data.is_blocked = isBlocked[0].is_blocked;
    data.block_remarks = isBlocked[0].block_remarks || '';
  } else if (isUnBlocked && isUnBlocked.length > 0) {
    data.is_blocked = isUnBlocked[0].is_blocked;
    data.unblock_remarks = isUnBlocked[0].unblock_remarks || '';
  } else {
    // Default case
    data.is_blocked = false;
  }
}
    const isDpl = DEEPAK_COMPANY_ID.includes(company_id);
 
    
    return (
      <div className="driver-modal">
        <div className="driver-backdrop" onClick={this.props.toggleAdd} />
        <div className="driver-card">
          <h2>Edit Driver Info</h2>
          <div className="driver-grid">
            {/* FIRST ROW: DL + DOB */}
            <div style={{ display: "flex", gap: "4px" }}>
              <div style={{ flex: 1 }}>
                <InputText
                  label="DL No"
                  placeholder="DL No"
                  id="dl_no"
                  value={data.dl_no}
                  changeHandler={this.onChangeHandler}
                  length={"16"}
                  required
                />
              </div>
              {!isDpl && (
              <div style={{ flex: 1, display: "flex", alignItems: "flex-end" }}>
                <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
                  <label style={{ fontSize: "13px", color: "#868e96", marginBottom: "6px" }}>
                    Driver DOB <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={data.dob ? new Date(data.dob) : null}
                    onChange={this.SelectDate.bind(this, "dob")}
                    placeholderText="DD/MM/YYYY"
                    maxDate={new Date()}
                    popperPlacement="bottom-start"
                  />
                </div>
              </div>
              )}
            </div>
 
            <div className="upload-section">
              <label className="upload-label">
                DL Image {!isDpl && <span className="text-danger">*</span>}
              </label>
              <div style={{ display: "flex", gap: "12px", marginTop: "8px" }}>
                <div className="upload-box" onClick={() => this.uploadUrl.click()}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="#6c757d"
                    viewBox="0 0 24 24" style={{ marginRight: "10px" }}>
                    <path d="M12 3l4 4h-3v6h-2V7H8l4-4zm-7 14v2h14v-2H5z" />
                  </svg>
                  <span>Upload Image</span>
                </div>
 
                {data.dlName && data.dlName.name && (
                  <div style={{
                    height: "60px", border: "1px solid #dee2e6", padding: "10px",
                    borderRadius: "8px", display: "flex", alignItems: "center",
                    gap: "10px", background: "#f8f9fa"
                  }}>
                    <div className="fs-12 curP" onClick={() => this.handleFileClickWithpresignedUrl(data.dlName.name)}>
                      {data.dlName.name}
                    </div>
                  </div>
                )}
              </div>
 
              <input
                type="file"
                ref={(e) => { this.uploadUrl = e; }}
                style={{ display: "none" }}
                accept=".jpeg, .jpg, .png"
                onChange={(e) => { this.uploadfiles(e, "dlName"); }}
                onClick={(e) => { e.target.value = null; }}
              />
            </div>
 
            {/* Form Fields Grid */}
            <div style={{
              marginTop: "12px", display: "grid",
              gridTemplateColumns: "1fr 1fr", columnGap: "4px", rowGap: "42px"
            }}>
              <InputText
                label="Driver Name"
                id="driver_name"
                value={data.driver_name ? data.driver_name.toUpperCase() : ""}
                placeholder="Driver Name"
                changeHandler={this.onChangeHandler}
                length={"45"}
                required
              />
              <InputText
                label="Driver Contact"
                id="cell_no"
                value={data.cell_no}
                placeholder="Driver Contact"
                changeHandler={this.onChangeHandler}
                length={"10"}
                isValidate={"numeric"}
                required
              />
              <InputText
                label="Driver Location"
                id="driver_alternative_location_id"
                value={data.driver_alternative_location_id}
                placeholder="Driver Location"
                changeHandler={this.onChangeHandler}
                length={"45"}
              />
              <InputText
                label="Driver A/C No"
                id="driver_acc_no"
                value={data.driver_acc_no}
                placeholder="Driver A/C No"
                changeHandler={this.onChangeHandler}
                length={"17"}
              />
              <InputText
                label="IFSC"
                id="driver_ifsc_code"
                value={data.driver_ifsc_code}
                placeholder="IFSC"
                changeHandler={this.onChangeHandler}
                length={"11"}
              />
              <div style={{ display: "flex", flexDirection: "column" }}>
                <label style={{ fontSize: "13px", color: "#868e96", marginBottom: "6px" }}>
                  DL validity date {!isDpl && <span className="text-danger">*</span>}
                </label>
                <DatePicker
                  dateFormat="dd/MM/yyyy"
                  selected={data.driver_detail_validity_date ? new Date(data.driver_detail_validity_date) : null}
                  onChange={this.SelectDate.bind(this, "driver_detail_validity_date")}
                  placeholderText={"DD/MM/YYYY"}
                  popperPlacement="bottom-start"
                />
              </div>
            </div>
 
            {/* Block / Whitelist Switch */}
            <div className="fBold fs-16 mt-10 mb-10 header-medium-color col-2 flex-1" style={{ color: "#868e96" }}>
              {AWL_COMPANY_IDS.includes(data.company_id)
                ? <span>Driver Block</span>
                : block ? "Black listed" : "White listed"}
              <div className="mt-10">
                <Switch onChange={this.handleSwitch} onColor="#528aea" checked={data.is_blocked} />
              </div>
            </div>
 
            {data.is_blocked ? (
              <div className="flex col-1">
                <InputText
                  placeholder={AWL_COMPANY_IDS.includes(data.company_id) ? "Block remark" : "Black listed remark"}
                  label={AWL_COMPANY_IDS.includes(data.company_id) ? "Block remark" : "Black listed remark"}
                  id="block_remarks"
                  value={data.block_remarks}
                  changeHandler={(value) => {
                    let { data } = this.state;
                    data.block_remarks = value;
                    this.setState({ data });
                  }}
                />
              </div>
            ) : (
              <div className="flex col-1" style={{ marginLeft: "5px" }}>
                <InputText
                  placeholder="White listed remark"
                  label="White listed remark"
                  id="unblock_remarks"
                  value={data.unblock_remarks}
                  changeHandler={(value) => {
                    let { data } = this.state;
                    data.unblock_remarks = value;
                    this.setState({ data });
                  }}
                />
              </div>
            )}
 
            {/* Location Section */}
            <div className="location-wrapper">
              <div className="location-header">
                <h3>Add Location</h3>
                <button className="btn-add" onClick={this.addLocation}>+ Add</button>
              </div>
              {data.preferredroute.map((value, index) => (
                <div className="location-row" key={index}>
                  <div className="form-field">
                    <InputText
                      label="Source"
                      placeholder="Source"
                      value={value.source}
                      changeHandler={(v) => {
                        let { data } = this.state;
                        data.preferredroute[index].source = v;
                        this.setState({ data });
                      }}
                    />
                  </div>
                  <div className="form-field">
                    <InputText
                      label="Destination"
                      placeholder="Destination"
                      value={value.destination}
                      changeHandler={(v) => {
                        let { data } = this.state;
                        data.preferredroute[index].destination = v;
                        this.setState({ data });
                      }}
                    />
                  </div>
                  <button className="btn-delete" onClick={() => this.deleteLocation(index)}>✕</button>
                </div>
              ))}
            </div>
          </div>
 
          {this.state.errorMsg && (
            <div style={{
              display: "flex", alignItems: "center", gap: "8px", marginTop: "8px",
              padding: "8px 10px", borderRadius: "6px",
              backgroundColor: "rgba(244, 67, 54, 0.1)", border: "#F44336",
              color: "#C62828", fontSize: "14px", fontWeight: 500
            }}>{this.state.errorMsg}</div>
          )}
 
          <div className="driver-footer">
            <Button value="Cancel" className="btn-outline" click={() => this.props.toggleAdd("Edit")} />
            <Button value="Save" className="btn-primary" click={this.onSave} />
            </div>
          </div>
        </div>
    );
  }
}
 
export default connect()(AddItem);
